import React, { useState, useEffect } from 'react';
import { TextField, Rating, Snackbar, Alert, useTheme } from '@mui/material';
import { Booking } from '../../../models/booking';
import { updateBookingField } from '../../../services/BookingService';
import { getRatingByBookingId, UpdateCustomerFeedBackRating } from '../../../services/feedBackRatingService';
import '../../../../styles/commonStyle.css';


interface RatingCategory {
  category: string;
  rating: number;
}

interface GiveRatingProps {
  showRatingModal: boolean
  booking: Booking;
  setShowRatingModal: (value: boolean) => void
}

const GiveFeedBackRating: React.FC<GiveRatingProps> = ({ showRatingModal, setShowRatingModal, booking }) => {
  const theme = useTheme()

  const [categories, setCategories] = useState<RatingCategory[]>([
    { category: 'Rash Driver', rating: 0 },
    { category: 'Clean Car', rating: 0 },
    { category: 'On Time', rating: 0 },
    { category: 'Overall Rating', rating: 0 },
  ]);

  const [comment, setComment] = useState('');
  const [btnDisable, setBtnDisable] = useState(false);
  const [disableRating, setDisableRating] = useState(false);
  const [commentBoxDisable, setCommentBoxDisable] = useState(false);
  const [feedBackErr, setFeedBackErr] = useState("")


  const getFeedBackRatingBybookingId = async () => {

    if (booking && booking._id) {
      const rating = await getRatingByBookingId(booking._id)
      // console.log("rating =" + JSON.stringify(rating))
      if (rating && rating.ratingsByCustomer) {
        setCommentBoxDisable(true)
        setDisableRating(true)
        setBtnDisable(true)
        setComment(rating && rating?.feedBackByCustomer !== "NA" ? rating?.feedBackByCustomer : "")

        setCategories((prevCategories) =>
          prevCategories.map((category) => {
            switch (category.category) {
              case 'Rash Driver':
                return { ...category, rating: parseInt(rating.ratingsByCustomer.rashDriver) };
              case 'Clean Car':
                return { ...category, rating: parseInt(rating.ratingsByCustomer.cleanCar) };
              case 'On Time':
                return { ...category, rating: parseInt(rating.ratingsByCustomer.onTime) };
              case 'Overall Rating':
                return { ...category, rating: parseInt(rating.ratingsByCustomer.overallRating) };
              default:
                return category;
            }
          })
        );
      }
    }
  }

  useEffect(() => {
    getFeedBackRatingBybookingId();
  }, [booking]);

  const handleRatingChange = (category: string, newRating: number) => {
    setCategories((prev) =>
      prev.map((c) => (c.category === category ? { ...c, rating: newRating } : c))
    );
    setFeedBackErr('')
  };

  const handleSubmit = async () => {
    const total = categories.reduce((sum, c) => sum + c.rating, 0);
    const avg = total / categories.length;
    if (avg === 0) {
      setFeedBackErr("Kindly provide your rating.");
      return;
    } else if (!comment) {
      setFeedBackErr("Kindly provide your comment.");
      return;
    }
    setFeedBackErr('')
    try {
      await updateBookingField(booking._id, "driverRating", avg.toString());
      const feedbackByCustomer = comment?.trim() || "NA";
      const customerRating = {
        rashDriver: categories[0].rating.toString(),
        cleanCar: categories[1].rating.toString(),
        onTime: categories[2].rating.toString(),
        overallRating: categories[3].rating.toString(),
      };

      await UpdateCustomerFeedBackRating(booking._id, customerRating, feedbackByCustomer);
      setShowRatingModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className={`modal fade ${showRatingModal ? 'show d-block' : ''}`}
        tabIndex={-1}
        role="dialog"
        style={{ backgroundColor: showRatingModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}
        aria-modal={showRatingModal}
      >
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Rate Your Ride</h5>
              <button type="button" className="btn-close" onClick={() => setShowRatingModal(false)} />
            </div>

            <div className="modal-body">
              {categories.map((cat) => (
                <div key={cat.category}
                  className="d-flex justify-content-between align-items-center mb-3 flex-wrap"
                >
                  <div className="fw-semibold me-3 text-start" style={{ minWidth: '120px' }}>{cat.category}</div>
                  <Rating
                    value={cat.rating}
                    onChange={(_, newValue) => handleRatingChange(cat.category, newValue ?? 0)}
                    disabled={disableRating}
                    style={{ color: "#25d366" }}
                  />
                </div>
              ))}

              <TextField
                label="Comments"
                multiline
                rows={4}
                fullWidth
                value={comment}
                disabled={commentBoxDisable}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Tell us how your ride was..."
                margin="normal"
              />
            </div>
            {feedBackErr &&
              <p className="text-center text-danger text-sm font-medium">{feedBackErr}</p>
            }
            <div className="modal-footer px-3 pb-3">
              <button
                type="button"
                className="btn btn-outline-secondary me-2"
                onClick={() => setShowRatingModal(false)}
              >
                Cancel
              </button>
              {!disableRating && (
                <button
                  type="button"
                  className="btn btn-outline-success me-2"
                  onClick={handleSubmit}
                  disabled={btnDisable}
                >
                  Submit
                </button>
              )}
            </div>

          </div>
        </div>
      </div>

    </>
  );
};

export default GiveFeedBackRating;